import { render, staticRenderFns } from "./SplitView.vue?vue&type=template&id=1b39c8d4&scoped=true"
import script from "./SplitView.vue?vue&type=script&lang=ts"
export * from "./SplitView.vue?vue&type=script&lang=ts"
import style0 from "./SplitView.vue?vue&type=style&index=0&id=1b39c8d4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b39c8d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b39c8d4')) {
      api.createRecord('1b39c8d4', component.options)
    } else {
      api.reload('1b39c8d4', component.options)
    }
    module.hot.accept("./SplitView.vue?vue&type=template&id=1b39c8d4&scoped=true", function () {
      api.rerender('1b39c8d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/SplitView.vue"
export default component.exports